export const API_ERROR_CODES = {
  accountAlreadyRegistered: 'INV_014',
  generalError: 'INV_000',
  invalidCaptcha: 'INV_015',
  invalidJWT: 'INV_009',
  inviteExpirationNotSet: 'INV_004',
  inviteExpiredOrNotFound: 'INV_005',
  inviteMissingZipCode: 'INV_006',
  inviteMissingEmail: 'INV_007',
  inviteRetrievalFailure: 'INV_001',
  jWTGenerationFailure: 'INV_008',
  passwordBanned: 'INV_010',
  passwordInvalid: 'INV_012',
  securityQuestionInvalid: 'INV_011',
  securityQuestionsRetrievalFailure: 'INV_002',
  userAlreadyExistsOnAccount: 'INV_019',
  userPreviouslyRegistered: 'INV_013',
  zipCodeMismatch: 'INV_003',
};

export const API_ERRORS = {
  accountHasPrimaryManager: {
    code: API_ERROR_CODES.accountAlreadyRegistered,
    heading: null,
    message: null,
  },
  default: {
    code: null,
    heading: 'Sorry, something went wrong',
    message:
      'Please try again, or contact us at (800) 391-3000 for assistance.',
  },
  inviteExpired: {
    code: API_ERROR_CODES.inviteExpiredOrNotFound,
    heading: null,
    message: null,
  },
  invalidZip: {
    code: API_ERROR_CODES.zipCodeMismatch,
    heading: 'INVALID ZIP CODE',
    message: 'Please check your account information and try again.',
  },
  passwordBanned: {
    code: API_ERROR_CODES.passwordBanned,
    heading: 'AN ERROR OCCURRED',
    message:
      'Unable to use password provided. Please try again with a different password.',
  },
  passwordInvalid: {
    code: API_ERROR_CODES.passwordInvalid,
    heading: 'AN ERROR OCCURRED',
    message:
      'Unable to use password provided. Please try again with a different password.',
  },
  sessionTimeout: {
    code: API_ERROR_CODES.invalidJWT,
    heading: null,
    message: null,
  },
  userAlreadyExistsOnAccount: {
    code: API_ERROR_CODES.userAlreadyExistsOnAccount,
    heading: null,
    message: null,
  },
  userAlreadyRegistered: {
    code: API_ERROR_CODES.userPreviouslyRegistered,
    heading: null,
    message: null,
  },
};

export const SAGA_CONTEXT_KEYS = {
  history: 'history',
};

export const ANALYTICS_PAGE_ERROR = {
  accountCreation: {
    eventAction: 'Registration Complete error',
    errorMessage: 'FMARR | account creation error',
  },
  startPage: {
    eventAction: 'start page error',
    errorMessage: 'FMARR | error loading start page',
  },
  zipVerify: {
    eventAction: 'Activate Your Account error',
    errorMessage: 'FMARR | error loading Activate Your Account page',
  },
};
